import{__module as e}from"../../_virtual/index5.js";
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/var n,o,t;n=e,o=!("undefined"==typeof window||!window.document||!window.document.createElement),t={canUseDOM:o,canUseWorkers:"undefined"!=typeof Worker,canUseEventListeners:o&&!(!window.addEventListener&&!window.attachEvent),canUseViewport:o&&!!window.screen},n.exports?n.exports=t:window.ExecutionEnvironment=t;var r=e.exports;export{r as e};
